import React from "react";

const CalendarSkeleton = () => {
  const renderSkeletonDays = () => {
    const days = [];
    for (let i = 0; i < 35; i++) {
      days.push(
        <div
          key={i}
          className="h-16 border border-gray-200 animate-pulse bg-gray-100"
        />
      );
    }
    return days;
  };

  return (
    <div className="space-y-4">
      <div className="bg-gray-50 p-4 border-b border-gray-200">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="w-8 h-8 rounded-lg bg-gray-200 animate-pulse" />
          <div className="flex items-center gap-4">
            <div className="w-32 h-9 rounded-md bg-gray-200 animate-pulse" />
            <div className="w-24 h-9 rounded-md bg-gray-200 animate-pulse" />
          </div>
          <div className="w-8 h-8 rounded-lg bg-gray-200 animate-pulse" />
        </div>
      </div>

      <div className="p-4">
        <div className="grid grid-cols-7 mb-2">
          {[...Array(7)].map((_, i) => (
            <div key={i} className="h-4 flex items-center justify-center">
              <div className="w-6 h-3 rounded bg-gray-200 animate-pulse" />
            </div>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-0 border border-gray-200 rounded-lg overflow-hidden">
          {renderSkeletonDays()}
        </div>

        <div className="mt-6 grid grid-cols-2 sm:flex sm:flex-wrap items-center gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex items-center gap-2">
              <div className="w-4 h-4 rounded bg-gray-200 animate-pulse" />
              <div className="w-16 h-3 rounded bg-gray-200 animate-pulse" />
            </div>
          ))}
        </div>
      </div>

      <div className="p-4 border-t border-gray-200">
        <div className="w-48 h-4 mb-4 rounded bg-gray-200 animate-pulse" />
        <div className="grid grid-cols-7 gap-2">
          {[...Array(7)].map((_, i) => (
            <div
              key={i}
              className="flex flex-col items-center space-y-2 animate-pulse"
            >
              <div className="w-4 h-4 rounded bg-gray-200" />
              <div className="w-8 h-3 rounded bg-gray-200" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarSkeleton;
